<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I would like to dedicate this book to the students I taught at Tongren University. Most of these were quite poor, from rural backgrounds, many from one of the ethnic minorities, principally the Miao, Dong and Tujia peoples. Immediately, these students welcomed me into their lives. They were open, warm-hearted and hard working. There were two classes in particular whom I taught for the whole three years, viz. college classes 1 and 2: the only teacher to do so. I lived amongst them, ate with them, walked with them, went on outings with them<span class="math inline">—</span>and I came to love them dearly. May God bless them always.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4905e3df